module.exports = __webpack_public_path__ + "img/blue_041.ea9fd9a8.png";